import styled from "styled-components";
import Colors from "../../constants/Colors";

export const UnitCircle = styled.div<{backgroundColor?: string, color?: string}>`
    width: 28px;
    height: 28px;
    border-radius: 14px;
    border: 2px solid white;
    margin-left: -5px;
    background-color: ${props=>props.backgroundColor? props.backgroundColor : Colors.SPM500};
    text-align: center;
    font-weight: bold;
    color: ${props=>props.color? props.color : 'white'};
`
export const ActivityStatus = styled.div<{active?: boolean}>`
    width: 10px;
    height: 10px;
    border-radius: 5px;
    margin-right: 5px;
    background-color: ${props=>props.active? Colors.success : Colors.GRAY400}
`

